export interface ProfCitationV1 {
  version: 1;
  id: `principle:${string}`;
  kind: 'principle';
  argomentoId: string;
  argomentoName: string;
  principleId: string;
  principleName: string;
  destination: {
    section: 'appendice';
    argomentoId: string;
    principleId: string;
  };
}

function nonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

/** Strict deterministic wire parser. Invalid and future versions are dropped. */
export function parseProfCitationV1(value: unknown): ProfCitationV1 | null {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
  const raw = value as Record<string, unknown>;
  if (
    raw.version !== 1
    || raw.kind !== 'principle'
    || !nonEmptyString(raw.id)
    || !raw.id.startsWith('principle:')
    || !nonEmptyString(raw.argomentoId)
    || !nonEmptyString(raw.argomentoName)
    || !nonEmptyString(raw.principleId)
    || !nonEmptyString(raw.principleName)
    || raw.id !== `principle:${raw.principleId}`
  ) return null;
  const principleMatch = /^((?:arg)\d+)_P[0-9A-Za-z._-]+$/.exec(raw.principleId);
  if (!/^arg\d+$/.test(raw.argomentoId) || principleMatch?.[1] !== raw.argomentoId) {
    return null;
  }

  if (typeof raw.destination !== 'object' || raw.destination === null || Array.isArray(raw.destination)) {
    return null;
  }
  const destination = raw.destination as Record<string, unknown>;
  if (
    destination.section !== 'appendice'
    || destination.argomentoId !== raw.argomentoId
    || destination.principleId !== raw.principleId
  ) return null;

  return {
    version: 1,
    id: raw.id as `principle:${string}`,
    kind: 'principle',
    argomentoId: raw.argomentoId,
    argomentoName: raw.argomentoName,
    principleId: raw.principleId,
    principleName: raw.principleName,
    destination: {
      section: 'appendice',
      argomentoId: raw.argomentoId,
      principleId: raw.principleId,
    },
  };
}
